import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    q: 'How quickly can I book a creator?',
    a: 'Most bookings are confirmed within 60 seconds. For same-day shoots, we recommend booking at least 2 hours in advance to ensure creator availability.',
  },
  {
    q: 'Are GoSnap creators verified?',
    a: 'Yes. Every creator on GoSnap goes through a multi-step verification process including portfolio review, equipment check, and a test shoot. Only the top 15% of applicants are approved.',
  },
  {
    q: 'How fast do I receive my reel?',
    a: 'Starter plan reels are delivered in 4 hours. Pro plan in 2-3 hours. For event shoots, highlights are typically ready the same day.',
  },
  {
    q: 'Can I request revisions?',
    a: 'Absolutely, Our creators are committed to getting it perfect.',
  },
  {
    q: 'What cities does GoSnap operate in?',
    a: 'We are currently live in Hyderabad with multilple creators. We are expanding to Bangalore, Mumbai, and Chennai in Q2 2026. Join our waitlist to get early access.',
  },
  {
    q: 'How does payment work?',
    a: 'Payment is collected securely at booking via UPI, card, or net banking. Creators are paid out within 24 hours of shoot completion.',
  },
];

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(null);

  const toggle = (i) => setOpenIdx(openIdx === i ? null : i);

  return (
    <section className="faq-sec" id="faq">
      <div className="container">
        <div className="faq-head reveal">
          <span className="sec-label">Got questions?</span>
          <h2 className="sec-h2">Everything You<br /><em>Need to Know</em></h2>
        </div>
        <div className="faq-list">
  {faqs.map((item, i) => (
    <div
      key={i}
      className={`faq-item ${openIdx === i ? 'open' : ''}`}
    >
      <button
        className="faq-q"
        onClick={() => toggle(i)}
        type="button"
      >
        <span>{item.q}</span>

        <span className="faq-icon">
          {openIdx === i ? '−' : '+'}
        </span>
      </button>

      {openIdx === i && (
        <div className="faq-a">
          {item.a}
        </div>
      )}
    </div>
  ))}
</div>
      </div>
    </section>
  );
};

export default FAQ;
